import { Flex, Box, CryptoIcon, FlexProps } from '@blockanalitica/ui';
import { ReactNode } from 'react';

export interface AssetProps extends Omit<FlexProps, 'name'> {
  address: string;
  symbol: string;
  network: string;
  iconSize?: string | number;
  name?: string | ReactNode;
  suffix?: string;
}

export default function Asset({
  address,
  symbol,
  network,
  name,
  suffix,
  iconSize = '5',
  ...rest
}: AssetProps) {
  return (
    <Flex gap={['s', 'xs']} alignItems="center" {...rest}>
      <CryptoIcon
        name={symbol}
        address={address}
        network={network}
        size={iconSize}
      />
      <Flex flexDirection="column" gap="4xs">
        <Box as="span">
          {symbol} {suffix}
        </Box>
        {name ? (
          <Box as="span" color="muted" fontSize="-1">
            {name}
          </Box>
        ) : null}
      </Flex>
    </Flex>
  );
}
